// Shared localStorage guard - Claude viewers and some embedded contexts throw on access.
export function isLocalStorageAvailable() {
    try {
        const test = '__localStorage_test__';
        window.localStorage.setItem(test, test);
        window.localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

export const canUseLocalStorage = isLocalStorageAvailable();

export function safeGet(key) {
    if (!canUseLocalStorage) return null;
    try {
        return localStorage.getItem(key);
    } catch (e) {
        return null;
    }
}

export function safeSet(key, value) {
    if (!canUseLocalStorage) return;
    try {
        localStorage.setItem(key, value);
    } catch (e) {}
}

export function safeRemove(key) {
    if (!canUseLocalStorage) return;
    try {
        localStorage.removeItem(key);
    } catch (e) {}
}
